import {
  getNativeDeviceToken
} from './nativeDeviceAuth';

const SUPABASE_URL =
  process.env
    .REACT_APP_SUPABASE_URL;

const SUPABASE_KEY =
  process.env
    .REACT_APP_SUPABASE_PUBLISHABLE_KEY;

async function callPolls(
  session,
  action,
  payload = {}
) {
  if (!session) {
    throw new Error(
      'A student session is required.'
    );
  }

  const body = {
    actorType:
      'student',
    action,
    ...payload
  };

  if (
    session.nativeDeviceSession ===
      true
  ) {
    const deviceToken =
      await getNativeDeviceToken();

    if (!deviceToken) {
      throw new Error(
        'A saved mobile login is required.'
      );
    }

    body.deviceToken =
      deviceToken;
  } else {
    const webSessionToken =
      String(
        session.webSessionToken ||
        ''
      ).trim();

    if (!webSessionToken) {
      throw new Error(
        'Your student web session is no longer available. Please sign in again.'
      );
    }

    body.webSessionToken =
      webSessionToken;
  }

  const response =
    await fetch(
      SUPABASE_URL +
        '/functions/v1/honors-polls',
      {
        method:
          'POST',
        headers: {
          apikey:
            SUPABASE_KEY,
          Authorization:
            'Bearer ' +
            SUPABASE_KEY,
          'Content-Type':
            'application/json'
        },
        body:
          JSON.stringify(
            body
          )
      }
    );

  const text =
    await response.text();

  const result =
    text
      ? JSON.parse(text)
      : null;

  if (
    !response.ok ||
    result?.ok === false
  ) {
    throw new Error(
      result?.error ||
      'Poll request failed.'
    );
  }

  return result;
}

export function listStudentHonorsPolls(
  session
) {
  return callPolls(
    session,
    'list'
  );
}

export function submitStudentHonorsPoll(
  session,
  pollId,
  answers
) {
  return callPolls(
    session,
    'submit',
    {
      pollId,
      answers
    }
  );
}
